<template>
  <div class="sp-template">
    <div class="h-title">订单费用</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form inline :model="queryForm" class="demo-form-inline" size="small">

          <!-- <el-form-item label="选择客户">
            <el-select v-model="queryForm.customerIds" filterable clearable multiple placeholder="选择客户">
              <el-option v-for="(d, i) in customers" :key="i" :label="d.name" :value="d.id"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="选择渠道">
            <el-select v-model="queryForm.productIds" filterable clearable multiple placeholder="选择渠道">
              <el-option v-for="(d, i) in channels" :key="i" :label="d.nameCN" :value="d.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始日期">
            <el-date-picker v-model.lazy="queryForm.startDate" type="date" value-format="yyyy-MM-dd" placeholder="开始日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="结束日期">
            <el-date-picker v-model.lazy="queryForm.endDate" type="date" value-format="yyyy-MM-dd" placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="订单号">
            <el-input type="textarea" v-model="orderIds" placeholder="多个订单号用回车分割"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button  v-if="in_configs(701)" type="primary" @click="searchTask()">搜索</el-button>
          </el-form-item>
          <el-form-item>
          <el-button  v-if="in_configs(702)"  size="small" type="warning" @click="exportOrderCost()">导出</el-button>
          </el-form-item>
        </el-form>

      </div>
      <!-- <vue-scroll :ops="ops"> -->
        <el-table :data="tableData" tooltip-effect="dark" border style="width: 100%;" max-height="800" ref="table">
          <el-table-column prop="orderId" label="订单号" width="150"></el-table-column>
          <el-table-column label="仓库">
            <template slot-scope="scope">
              {{warehouseDataMaps[scope.row.warehouseId]}}
            </template>
          </el-table-column>
          <el-table-column label="渠道">
            <template slot-scope="scope">
              {{channelsMaps[scope.row.productId]}}
            </template>
          </el-table-column>
          <el-table-column label="客户单号" width="200">
            <template slot-scope="scope">
              <span v-html="judge(scope.row.customerNumber)"></span>
              <!-- {{judge(scope.row.customerNumber)}} -->
            </template>
          </el-table-column>
          <el-table-column label="实重/计费重" width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.actuallyWeight !== null">
                <span class="name-tooltips first">实</span>{{scope.row.actuallyWeight.toFixed(3)}}</div>
              <div v-if="scope.row.chargingWeight !== null">
                <span class="name-tooltips second">计</span>{{scope.row.chargingWeight.toFixed(3)}}</div>
            </template>
          </el-table-column>
          
          <el-table-column prop="totalAmount" label="总费用"></el-table-column>
          
          <el-table-column width="180" label="费用类型">
            <template slot-scope="scope">
              <div v-for="(d, i) in scope.row.items" :key="i" class="trace-item">{{d.serviceType}}</div>
            </template>
          </el-table-column>

          <el-table-column width="120" label="金额">
            <template slot-scope="scope">
              <div v-for="(d, i) in scope.row.items" :key="i" class="trace-item">{{d.amount}}</div>
              
            </template>
          </el-table-column>
          <el-table-column width="120" label="币种">
            <template slot-scope="scope">
              <div v-for="(d, i) in scope.row.items" :key="i" class="trace-item">{{d.currency}}</div>
              
            </template>
          </el-table-column>
          <el-table-column width="200" label="交易时间">
            <template slot-scope="scope">
              <div v-for="(d, i) in scope.row.items" :key="i" class="trace-item">{{d.txDate}}</div>
              
            </template>
          </el-table-column>
          <el-table-column width="120" label="明细">
            <template slot-scope="scope">
              <div v-for="(d, i) in scope.row.items" :key="i" class="trace-item">
                <a v-if="d.serviceType == 'mainCharge'" href="#" title="点击查看明细" @click.prevent="showAllBasicVariables(d.trace)">
                  <i class="el-icon-zoom-in"></i>
                </a>
                {{d.serviceType == "mainCharge" ? d.trace : null}}
              </div>
              
            </template>
          </el-table-column>
          <el-table-column width="120" label="备注" fixed="right">
            <template slot-scope="scope">
              <div v-for="(d, i) in scope.row.items" :key="i" class="trace-item">
                <el-tooltip v-if="d.remarks && d.remarks !== ''" effect="dark" placement="top">
                  <div slot="content">
                    <div>{{d.remarks}}</div>
                  </div>
                  <i class="el-icon-question"></i>
                </el-tooltip>
                <span>{{d.remarks}}</span>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column label="操作">
            <template slot-scope="scope">
              <i size="mini" class="el-icon-plus" @click="addOrderCharge( scope.row)"></i>
            </template>
          </el-table-column> -->
        </el-table>
      <!-- </vue-scroll> -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>

      <el-dialog title="明细" :visible.sync="dialogShowVariables" append-to-body>
        <p v-if="formulaStr !== ''" v-html="formulaStr"></p>
      </el-dialog>
      <!-- 添加费用 -->
      <el-dialog title="添加费用" :visible.sync="chargeVisible">
        <el-form :model="addChargeForm" size="small" id="uploadForm">
          <el-form-item label="客户名称" label-width="120px">{{addChargeForm.customerName}}</el-form-item>
          <el-form-item label="订单号" label-width="120px">{{addChargeForm.orderId}}</el-form-item>
          <el-form-item label="费用类型" label-width="120px">
            <el-select v-model="addChargeForm.chargeType">
              <el-option v-for="(d, i) in chargeType" :key="i" :label="d.name" :value="d.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="币种" label-width="120px">
            <el-select name="currency" v-model="addChargeForm.currency">
              <el-option v-for="currency in currencies" :label="currency.name" :value="currency.value" :key="currency.name"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="金额" label-width="120px">
            <el-input type="number" min="0" v-model.lazy="addChargeForm.amount" placeholder="金额"></el-input>
          </el-form-item>

          <el-form-item label="备注" label-width="120px">
            <el-input type="textarea" v-model="addChargeForm.remarks"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="chargeVisible=false">取 消</el-button>
          <el-button type="primary" @click="addChargeDone">确 定</el-button>
        </div>
      </el-dialog>
    </el-card>
    <form id="theform" target="_blank"></form>
  </div>
</template>
<script>
import { base64ToUint8Array, dateFormat } from '@/util/formUtil'
export default {
  data() {
    return {
      ops: {
        rail: {
          vRail: {
            width: "6px",
            pos: "left",
            background: "#A9A9A9",
            opacity: 0
          },
          //
          hRail: {
            height: "6px",
            pos: "top",
            background: "#A9A9A9",
            opacity: 0
          }
        },
        bar: {
          showDelay: 500,
          vBar: {
            background: "#A9A9A9",
            keepShow: false,
            opacity: 1,
            hover: false
          },
          //
          hBar: {
            background: "#A9A9A9",
            keepShow: false,
            opacity: 1,
            hover: false
          }
        }
      },
      orderIds: "",
      queryForm: {
        orderIds: [],
        customerIds: [],
        productIds: [],
        startDate: "",
        endDate: "",
        export: 0,
        currentPage: 1,
        pageSize: 10
      },
      //表单数据
      tableData: [],
      customers: [],
      customerMaps: {},
      channels: [],
      channelsMaps: {},
      warehouseData: [],
      warehouseDataMaps: {},
      chargeType: [],
      chargeTypeMap: {},
      currencies: [
        { name: "美元", value: "USD" },
        { name: "欧元", value: "EUR" },
        { name: "人民币", value: "CNY" },
        { name: "港币", value: "HKD" },
        { name: "日元", value: "JPY" }
      ],
      chargeVisible: false,
      //
      addChargeForm: {
        customerName: "",
        orderId: "",
        chargeType: "",
        currency: "",
        amount: 0,
        remarks: ""
      },
      dialogShowVariables: false,
      formulaStr: "",
      //分页的数据
      pageSizes: [10, 20, 50, 100],
      pageSize: 10,
      total: 0,
      currentPage: 1 //当前页
    };
  },
  filters: {
    formatTime(val) {
      if (val != "") {
        return (
          new Date(val).getFullYear() +
          "-" +
          ("0" + (new Date(val).getMonth() + 1)).slice(-2) +
          "-" +
          ("0" + new Date(val).getDate()).slice(-2) +
          " " +
          ("0" + new Date(val).getHours()).slice(-2) +
          ":" +
          ("0" + new Date(val).getMinutes()).slice(-2) +
          ":" +
          ("0" + new Date(val).getSeconds()).slice(-2)
        );
      }
    }
  },
  created() {
    setTimeout(() => {
      this.initData();
      //this.getChargeType();
    }, 1000);
  },
  methods: {
    judge(data) {
      if (data) {
        return data.replace(/,/g, "<br>");
      }
    },
    showAllBasicVariables(vars) {
      this.dialogShowVariables = true;
      this.formulaStr = vars.replace(/\n/g, "<br>");
    },
    initData() {
      let _this = this;
      _this.loadChannel();
      _this.query();
      _this.loadAllChannel();
      _this.loadWarehouse();
    },
    loadChannel() {
      let _this = this;
      _this.channels = [];
      this.$request1({
        method: 'GET',
        url: '/channel'
      })
        .then(response => {
          if (response.data.data && response.data.data.length > 0) {
            this.channels = response.data.data;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    loadAllChannel() {
      let _this = this;
      _this.channels = [];
      this.$request1({
        method: 'GET',
        url: '/channel/all'
      })
        .then(response => {
          if (response.data.data && response.data.data.length > 0) {
            let channels = response.data.data;
            channels.forEach((d, i) => {
              this.channelsMaps[d.id] = d.nameCN;
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    loadWarehouse() {
      let _this = this;
      this.$request1({
        method: 'GET',
        url: '/warehouse'
      })
        .then(response => {
          if (response.data.data && response.data.data.length > 0) {
            this.warehouseData = response.data.data;
            this.warehouseData.forEach((d, i) => {
              this.warehouseDataMaps[d.id] = d.name;
            });            
          }

          _this.query();
          
        })
        .catch(error => {
          console.log(error);
        });
    },
    searchTask() {
      this.currentPage = 1;
      this.query();
    },
    exportOrderCost() {
      let _this = this;
      this.queryForm.orderIds = [];
      if (this.orderIds !== null && this.orderIds !== "") {
        let queryOrderIds = this.orderIds.split(/[\n]+/);
        for (let item of queryOrderIds) {
          if (item.trim() != "") {
            if (this.queryForm.orderIds.indexOf(item) == -1) {
              this.queryForm.orderIds.push(item);
            }
          }
        }
      }

      this.queryForm.export = 1;

      var url = tmsSpringUrl + '/order/charge-list';

      this.$request1({
          url: url,
          method: 'post',
          data: this.queryForm
        }).then(res => {
          const link = document.createElement('a')
          let array = base64ToUint8Array(res.data)
          let blob = new Blob([array])
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob)
          let timestr = dateFormat(new Date(), 'yyyyMMddHHmmss')
          link.setAttribute('download', `charge_${timestr}.xlsx`)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })


      // var url = tmsSpringUrl + '/order/charge-list';

      //   var form = document.createElement("form");
      //   form.method = 'get';
      //   form.action = url;
      //   form.target = '_blank';
      //   document.body.appendChild(form);


      //   var input = document.createElement("input");
  		// input.type = "hidden";
  		// input.name = 'data';
  		// input.value = JSON.stringify(this.queryForm);
      //   form.appendChild(input);          
      //   //console.log(form);
      //   form.submit();
        
    },
    query() {
      let _this = this;
      this.queryForm.orderIds = [];
      if (this.orderIds !== null && this.orderIds !== "") {
        let queryOrderIds = this.orderIds.split(/[\n]+/);
        for (let item of queryOrderIds) {
          if (item.trim() != "") {
            if (this.queryForm.orderIds.indexOf(item) == -1) {
              this.queryForm.orderIds.push(item);
            }
          }
        }
      }

      this.queryForm.export = 0;
      this.$request1({
        method: 'post',
        url: '/order/charge-list',
        withCredentials: true,
        data: {
          orderIds: this.queryForm.orderIds,
          productIds: this.queryForm.productIds,
          startDate: this.queryForm.startDate,
          endDate: this.queryForm.endDate,
          currentPage: this.currentPage,
          pageSize: this.pageSize,
          export: this.queryForm.export
        }
      })
        .then(response => {
          let data = response.data;
          if (data.success) {
            this.total = data.total;
            if (this.total > 0) {
              this.tableData = data.data;
            } else {
              this.tableData = [];
              this.total = 0;
            }
          } else {
            _this.$notify.error({
              title: "错误",
              message: data.message
            });
          }
        })
        .catch(error => {
          if (error.response) {
            _this.$notify.error({
              title: "错误",
              message: error.response.data
            });
          }
        });
    },
    //  添加费用
    addOrderCharge(row) {
      this.addChargeForm.orderId = row.orderId;
      this.addChargeForm.customerName = this.customerMaps[row.orgOwner];
      this.addChargeForm.amount = 0.0;
      this.addChargeForm.remarks = "";
      this.chargeVisible = true;
    },
    // 确定添加费用
    addChargeDone() {
      // if (this.addChargeForm.chargeType == "") {
      //   this.$message.error("请选择费用类型");
      //   return;
      // }
      // if (this.addChargeForm.currency == "") {
      //   this.$message.error("请选择币种");
      //   return;
      // }
      // if (this.addChargeForm.amount == 0) {
      //   this.$message.error("请输入费用金额");
      //   return;
      // }
      // // return;
      // this.$request1({
      //   method: jsRoutes.controllers.charge.OrderChargeController.addOrderCharge().type,
      //   url: jsRoutes.controllers.charge.OrderChargeController.addOrderCharge(),
      //   data: this.addChargeForm,
      //   withCredentials: true
      // })
      //   .then(response => {
      //     let data = response.data;
      //     if (data.success) {
      //       this.query();
      //       this.chargeVisible = false;
      //     } else {
      //       this.$message.error("操作失败：" + data.message);
      //     }
      //   })
      //   .catch(error => {
      //     _this.$notify.error({
      //       title: "错误",
      //       message: error.response.data
      //     });
      //   });
    },
    //分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.query();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.query();
    }
  }
};
</script>
<style lang="scss" scoped>
.el-table .cell {
  .trace-item {
    height: 34px;
    line-height: 34px;
    margin: 0 -10px;
    padding: 0 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-bottom: 1px solid #ebeef5;
  }
  > .trace-item:first-child {
    margin-top: -10px;
  }
  > .trace-item:last-child {
    border-bottom: none;
    margin-bottom: -10px;
  }
}
.item {
  width: 800px;
}
</style>


// WEBPACK FOOTER //
// src/views/charge/ordercharge.vue